import React, { useContext, useEffect, useState } from 'react';
import snapshotGroupimg from '../../../../Assets/Images/snapshotGroupImg.png';
import flow_HM from '../../../../Assets/Images/flowScoreIcons/H-M.png';
import flow_HS from '../../../../Assets/Images/flowScoreIcons/H-S.png';
import flow_HST from '../../../../Assets/Images/flowScoreIcons/H-ST.png';
import flow_MH from '../../../../Assets/Images/flowScoreIcons/M-H.png';
import flow_MS from '../../../../Assets/Images/flowScoreIcons/M-S.png';
import flow_MST from '../../../../Assets/Images/flowScoreIcons/M-ST.png';
import flow_SH from '../../../../Assets/Images/flowScoreIcons/S-H.png';
import flow_SM from '../../../../Assets/Images/flowScoreIcons/S-M.png';
import flow_SST from '../../../../Assets/Images/flowScoreIcons/S-ST.png';
import flow_STH from '../../../../Assets/Images/flowScoreIcons/ST-H.png';
import flow_STM from '../../../../Assets/Images/flowScoreIcons/ST-M.png';
import flow_STS from '../../../../Assets/Images/flowScoreIcons/ST-S.png';
import overviewImg from '../../../../Assets/Images/Overview.png';
import logo1 from '../../../../Assets/Images/logo1.png';
import logo5 from '../../../../Assets/Images/logo5.png';
import logo6 from '../../../../Assets/Images/logo6.png';
import logo7 from '../../../../Assets/Images/logo7.png';
import collaborativelogo from '../../../../Assets/Images/COLLABORATIVE.png';
import stratrgiclogo from '../../../../Assets/Images/STRATEGIC.png';
import visionarylogo from '../../../../Assets/Images/VISIONARY.png';
import performancelogo from '../../../../Assets/Images/PERFORMANCE.png';
import GrowthLogo from '../../../../Assets/Images/growth-new.png';
import FixedLogo from '../../../../Assets/Images/fixed-new.png';
import ConditionalLogo from '../../../../Assets/Images/conditional_edit.png';
import GroupStarterQuadrantChartPreview from './GroupStarterQuadrantChartPreview';
import FooterPreview from '../../../GeneratePdf/FooterPreview';
import GroupReportContext from '../../../../Context/GroupReportContext';
import HeaderPreview from '../../../GeneratePdf/HeaderPreview';
import { getMindsetSum } from '../../../../utils/helper';
import { applyFullTieOrder } from '../../../../utils/quadrantTieOrder';

// Hierarchy for tie-breaking: lower number = higher priority
const QUADRANT_HIERARCHY = {
  heart: 0,      // Highest priority
  soul: 1,
  mind: 2,
  strength: 3    // Lowest priority
};

// Comparator function for sorting quadrants with tie-breaking
const compareQuadrants = (a, b) => {
  // First compare by avg/value (descending)
  const valueDiff = (b.avg ?? b.value ?? 0) - (a.avg ?? a.value ?? 0);
  if (valueDiff !== 0) return valueDiff;

  // If values are equal, compare by hierarchy (ascending - lower number = higher priority)
  const aHierarchy = QUADRANT_HIERARCHY[a.name?.toLowerCase()] ?? 999;
  const bHierarchy = QUADRANT_HIERARCHY[b.name?.toLowerCase()] ?? 999;
  return aHierarchy - bHierarchy;
};

// Hierarchy for tie-breaking: lower number = higher priority
const LEADERSHIP_HIERARCHY = {
  collaborative: 0,  // Highest priority
  visionary: 1,
  strategic: 2,
  performance: 3    // Lowest priority
};

// Comparator function for sorting leadership quadrants with tie-breaking
const compareLeadershipQuadrants = (a, b) => {
  // First compare by score (descending)
  const scoreDiff = b.score - a.score;
  if (scoreDiff !== 0) return scoreDiff;

  // If scores are equal, compare by hierarchy (ascending - lower number = higher priority)
  const aHierarchy = LEADERSHIP_HIERARCHY[a.name.toLowerCase()] ?? 999;
  const bHierarchy = LEADERSHIP_HIERARCHY[b.name.toLowerCase()] ?? 999;
  return aHierarchy - bHierarchy;
};

export default function SnapshotSecondGroup({ apiData, previewData, reportType, pageNumber }) {
  const groupReportCtx = useContext(GroupReportContext);
  const { averagePercentages, averagePercentagesLeadership } = groupReportCtx;
  const selectedReport = groupReportCtx?.selectedReport;
  const { getPercentileFromScore } = useContext(GroupReportContext);

  const [groupResults, setGroupResults] = useState({
    starters: [],
    flows: [],
    leadership: [],
    mindset: [],
  });

  const [quadrantData, setQuadrantData] = useState(null);
  const [isQuadrantDataReceived, setIsQuadrantDataReceived] = useState(false);

  const _mapPctToMindset = (p) => {
    if (p < 36) return "fixed";
    if (p >= 36 && p < 66) return "conditional";
    if (p >= 66) return "growth";
    return "conditional";
  };


  useEffect(() => {
    if (!quadrantData || !isQuadrantDataReceived) {
      return;
    }

    setGroupResults((prev) => {
      const newResults = { ...prev };

      if (quadrantData.highestQuadrant) {
        newResults.starters = [quadrantData.highestQuadrant];
      }

      if (quadrantData.highestQuadrant && quadrantData.secondHighestQuadrant) {
        const flow = `${quadrantData.highestQuadrant}_to_${quadrantData.secondHighestQuadrant}`;
        newResults.flows = [flow];
      }

      return newResults;
    });
  }, [quadrantData, isQuadrantDataReceived]);

  useEffect(() => {
    // Use the same logic as GroupMindsetResult to get the correct data
    const pickResults = (previewData, apiData, reportType) => {
      if (Array.isArray(previewData)) {
        const match = previewData.find(x => x?.reportType === reportType);
        if (match?.results) return match.results;
      }
      if (Array.isArray(apiData?.results)) return apiData.results;
      return [];
    };

    const dataToProcess = pickResults(previewData, apiData, reportType);
    if (!dataToProcess && !Array.isArray(averagePercentagesLeadership)) return;

    const results = { leadership: [], mindset: [] };

    const apl = averagePercentagesLeadership;
    if (Array.isArray(apl) && apl.length) {
      const s = apl.find((el) => el?.name === 'Strategic')?.avg ?? 0;
      const v = apl.find((el) => el?.name === 'Visionary')?.avg ?? 0;
      const p = apl.find((el) => el?.name === 'Performance')?.avg ?? 0;
      const c = apl.find((el) => el?.name === 'Collaborative')?.avg ?? 0;

      const quadrants = [
        { name: 'strategic', score: Number(s) || 0 },
        { name: 'visionary', score: Number(v) || 0 },
        { name: 'performance', score: Number(p) || 0 },
        { name: 'collaborative', score: Number(c) || 0 },
      ];

      const sorted = applyFullTieOrder(quadrants.sort(compareLeadershipQuadrants), (q) => q.name, (q) => q.score);
      const highest = sorted[0]?.name || '';

      results.leadership = highest ? [highest] : [];
    } else {
      const allLeadershipScores = {
        collaborative: [],
        strategic: [],
        visionary: [],
        performance: [],
      };

      Object.values(dataToProcess || {}).forEach((assessment) => {
        if (!assessment?.variables) return;
        const variables = assessment.variables;

        const pick = (key) => {
          const v = variables.find((x) => x?.variable === key);
          const num = typeof v?.score === 'number' ? v.score : Number(v?.score ?? NaN);
          return Number.isFinite(num) ? num : 0;
        };

        const collaborative = pick('col_round1_m');
        const strategic = pick('strat_round1_m');
        const visionary = pick('vis_round1_m');
        const performance = pick('per_round1_m');

        allLeadershipScores.collaborative.push(collaborative);
        allLeadershipScores.strategic.push(strategic);
        allLeadershipScores.visionary.push(visionary);
        allLeadershipScores.performance.push(performance);
      });

      const avg = (arr) => {
        const nums = arr.filter(Number.isFinite);
        return nums.length ? nums.reduce((a, b) => a + b, 0) / nums.length : 0;
      };

      const leadershipAverages = {
        collaborative: avg(allLeadershipScores.collaborative),
        strategic: avg(allLeadershipScores.strategic),
        visionary: avg(allLeadershipScores.visionary),
        performance: avg(allLeadershipScores.performance),
      };

      const quadrants = [
        { name: 'collaborative', score: leadershipAverages.collaborative },
        { name: 'strategic', score: leadershipAverages.strategic },
        { name: 'visionary', score: leadershipAverages.visionary },
        { name: 'performance', score: leadershipAverages.performance },
      ];

      const sorted = applyFullTieOrder(quadrants.sort(compareLeadershipQuadrants), (q) => q.name, (q) => q.score);
      const highest = sorted[0]?.name || '';

      results.leadership = highest ? [highest] : [];
    }

    const memberRawScores = [];
    Object.values(dataToProcess || {}).forEach((assessment) => {
      if (!assessment?.variables) return;
      const mindsetSum = getMindsetSum(assessment.variables);
      if (mindsetSum > 0) {
        memberRawScores.push(mindsetSum);
      }
    });

    const contextPct = Number.isFinite(groupReportCtx?.averagePercentagesMindset)
      ? groupReportCtx.averagePercentagesMindset
      : 0;

    const avgRawScore = memberRawScores.length > 0
      ? memberRawScores.reduce((a, b) => a + b, 0) / memberRawScores.length
      : contextPct;

    const groupPct = getPercentileFromScore(avgRawScore);
    const averageMindset = _mapPctToMindset(Math.round(groupPct));

    setGroupResults((prev) => ({
      ...prev,
      leadership: results.leadership,
      mindset: [averageMindset],
    }));
  }, [previewData, apiData, averagePercentagesLeadership, groupReportCtx?.averagePercentagesMindset]);

  // ---------- Strength/Heart/Soul/Mind averages -> quadrantData ----------
  useEffect(() => {
    const avg = [
      averagePercentages?.find((el) => el?.name === 'Strength')?.avg,
      averagePercentages?.find((el) => el?.name === 'Heart')?.avg,
      averagePercentages?.find((el) => el?.name === 'Soul')?.avg,
      averagePercentages?.find((el) => el?.name === 'Mind')?.avg,
    ];

    const getHighestQuadrant = (a) => {
      const quadrants = [
        { name: 'Strength', value: a[0] },
        { name: 'Heart', value: a[1] },
        { name: 'Soul', value: a[2] },
        { name: 'Mind', value: a[3] },
      ];
      const sorted = applyFullTieOrder([...quadrants].sort(compareQuadrants), (q) => q.name, (q) => q.value);
      return sorted[0]?.name;
    };

    const getSecondHighestQuadrant = (a) => {
      const quadrants = [
        { name: 'Strength', value: a[0] },
        { name: 'Heart', value: a[1] },
        { name: 'Soul', value: a[2] },
        { name: 'Mind', value: a[3] },
      ];
      const sorted = applyFullTieOrder([...quadrants].sort(compareQuadrants), (q) => q.name, (q) => q.value);
      return sorted[1]?.name;
    };

    const averagesReplacement = {
      strength: averagePercentages?.find((el) => el?.name === 'Strength')?.avg,
      heart: averagePercentages?.find((el) => el?.name === 'Heart')?.avg,
      soul: averagePercentages?.find((el) => el?.name === 'Soul')?.avg,
      mind: averagePercentages?.find((el) => el?.name === 'Mind')?.avg,
      highestQuadrant: getHighestQuadrant(avg),
      secondHighestQuadrant: getSecondHighestQuadrant(avg),
    };

    setQuadrantData(averagesReplacement);
    setIsQuadrantDataReceived(true);
  }, [averagePercentages]);

  const getStarterLogo = (starterRaw) => {
    const starter = String(starterRaw || '').toLowerCase();
    if (starter === 'heart') return logo1;
    if (starter === 'strength') return logo5;
    if (starter === 'soul') return logo7;
    if (starter === 'mind') return logo6;
    return logo1;
  };

  const getFlowImage = (flow) => {
    const images = {
      heart_to_soul: flow_HS,
      heart_to_mind: flow_HM,
      heart_to_strength: flow_HST,
      mind_to_heart: flow_MH,
      mind_to_soul: flow_MS,
      mind_to_strength: flow_MST,
      soul_to_heart: flow_SH,
      soul_to_mind: flow_SM,
      soul_to_strength: flow_SST,
      strength_to_heart: flow_STH,
      strength_to_mind: flow_STM,
      strength_to_soul: flow_STS,
    };
    const image = images[flow?.toLowerCase()] || overviewImg;
    return image;
  };

  const getFlowHead = (flow) => {
    const formatted = flow.split('_')
      .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
      .join(' ');
    return formatted;
  };

  const getLeadershipLogo = (type) => {
    if (type === 'collaborative') return collaborativelogo;
    if (type === 'strategic') return stratrgiclogo;
    if (type === 'performance') return performancelogo;
    if (type === 'visionary') return visionarylogo;
    return collaborativelogo;
  };

  const getMindsetLogo = (category) => {
    switch (category) {
      case 'growth':
        return GrowthLogo;
      case 'conditional':
        return ConditionalLogo;
      case 'fixed':
        return FixedLogo;
      default:
        return GrowthLogo;
    }
  };

  const capitalizeWords = (value) =>
    String(value || '')
      .split(' ')
      .filter(Boolean)
      .map((word) => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
      .join(' ');

  const clientData = JSON.parse(localStorage.getItem('clientData') || '{}');

  const starterItems = quadrantData?.highestQuadrant
    ? [{
      icon: getStarterLogo(quadrantData.highestQuadrant),
      text: `GROUP: ${quadrantData.highestQuadrant}-Starter`,
    }]
    : [];

  const flowItems = groupResults.flows.map((flow) => ({
    icon: getFlowImage(flow),
    text: `GROUP: ${getFlowHead(flow)}`,
  }));

  const leadershipItems = groupResults.leadership.map((style) => ({
    icon: getLeadershipLogo(style),
    text: `GROUP: ${capitalizeWords(style)}`,
  }));

  const mindsetItems = groupResults.mindset.map((type) => ({
    icon: getMindsetLogo(type),
    text: `GROUP: ${capitalizeWords(type)}`,
  }));

  const resultsData = [
    [
      { label: "Starter", items: starterItems },
      { label: "Leadership", items: leadershipItems },
    ],
    [
      { label: "Flow", items: flowItems },
      { label: "Mindset", items: mindsetItems },
    ],
  ];


  return (
    <div>
      <div className='group-snapshot-results' style={{ fontFamily: 'Helvetica, sans-serif', backgroundColor: '#ffffff', }}>
        <HeaderPreview />
        <h2 style={{ color: '#00577D', fontSize: '14px', fontWeight: '700', lineHeight: "18px", padding: '16px 0px', margin: 0 }}>
          YOUR GROUP SNAPSHOT RESULTS
        </h2>

        <div style={{ fontSize: '10px', lineHeight: '14px', marginBottom: '16px' }}>
          <p style={{ margin: 0 }}><span style={{ color: '#000000', fontSize: '10px', fontWeight: '700', lineHeight: "14px", margin: 0 }}>Team Name:</span>
          <span style={{ textTransform: "capitalize" }}> {apiData?.teamname || 'N/A'}</span></p>
          <p style={{ margin: 0 }} ><span style={{ color: '#000000', fontSize: '10px', fontWeight: '700', lineHeight: "14px", margin: 0 }}>Organization:</span> {clientData?.company || 'N/A'}</p>
          <p style={{ margin: 0 }} ><span style={{ color: '#000000', fontSize: '10px', fontWeight: '700', lineHeight: "14px", margin: 0 }}>Group/Team ID:</span> {clientData?.groupid || 'N/A'}</p>
          <p style={{ margin: 0 }} ><span style={{ color: '#000000', fontSize: '10px', fontWeight: '700', lineHeight: "14px", margin: 0 }}>Facilitator:</span> {localStorage.getItem("userName") || 'N/A'}</p>
          <p style={{ margin: 0 }}><span style={{ color: '#000000', fontSize: '10px', fontWeight: '700', lineHeight: "14px", margin: 0 }}>Assessment:</span> Individuals</p>
        </div>

        <div style={styles.cardsContainer}>
          {resultsData.map((column, colIndex) => (
            <div key={colIndex} style={colIndex === 0 ? styles.leftColumn : styles.rightColumn}>
              {column.map((card, cardIndex) => {
                const displayItems = card.items?.length
                  ? card.items
                  : [{ icon: overviewImg, text: "N/A" }];
                return (
                <div key={cardIndex} style={styles.cardWrapper}>
                  <div style={styles.card}></div>
                  <div style={styles.cardLabel}>{card.label}</div>
                  <div style={styles.cardContent}>
                    {displayItems.map((item, itemIndex) => (
                      <div key={itemIndex} style={styles.itemRow}>
                        <div style={styles.iconWrapper}>
                          <img
                            src={item.icon}
                            alt={card.label}
                            style={{
                              ...styles.icon,
                              borderRadius: "50%",
                            }}
                          />
                        </div>
                        <span style={styles.cardText}>{item.text}</span>
                      </div>
                    ))}
                  </div>
                </div>
              );
              })}
            </div>
          ))}
        </div>
      </div>

      <FooterPreview pageNumber={pageNumber} reportType={reportType} />
    </div >

  );
}


const styles = {
  pageWrapper: { backgroundColor: "#FFFFFF" },
  mainTitle: { fontFamily: "Helvetica", fontStyle: "normal", fontWeight: 700, fontSize: "14px", lineHeight: "18px", color: "#00577D", margin: 0, padding: "16px 0px" },
  introText: { fontFamily: "Helvetica", fontStyle: "normal", fontWeight: 700, fontSize: "10px", lineHeight: "14px", color: "#000000", margin: 0, paddingBottom: "16px" },
  subText: { fontFamily: "Helvetica", fontStyle: "normal", fontWeight: 400, fontSize: "10px", lineHeight: "14px", color: "#000000", margin: 0, paddingBottom: "16px" },
  rememberTitle: { fontFamily: "Helvetica", fontStyle: "normal", fontWeight: 700, fontSize: "10px", lineHeight: "14px", color: "#000000", margin: 0, paddingBottom: "10px" },
  rememberItem: { fontFamily: "Helvetica", fontStyle: "normal", fontWeight: 400, fontSize: "10px", lineHeight: "14px", color: "#000000", margin: 0, paddingBottom: "6px" },
  resultsTitle: { fontFamily: "Helvetica", fontStyle: "normal", fontWeight: 700, fontSize: "14px", lineHeight: "18px", color: "#00577D", margin: 0, padding: "16px 0px" },
  cardsContainer: { display: "flex", flexDirection: "row", alignItems: "center", justifyContent: "center", padding: "16px 0px", gap: "24px" },
  leftColumn: { display: "flex", flexDirection: "column", alignItems: "flex-start", padding: "0px", gap: "24px", width: "208px", height: "188px" },
  rightColumn: { display: "flex", flexDirection: "column", alignItems: "flex-start", padding: "0px", gap: "24px", width: "208px", height: "187.94px" },
  cardWrapper: { position: "relative", width: "208px", height: "82px" },
  card: { boxSizing: "border-box", position: "absolute", width: "208px", height: "73px", left: "0px", top: "9px", background: "#FFFFFF", border: "2px solid #00577D", borderRadius: "10px" },
  cardLabel: { position: "relative", width: "12ch", margin: "0px auto", left: "0px", top: "0px", background: "#FFFFFF", fontFamily: "Helvetica", fontStyle: "normal", fontWeight: 700, fontSize: "11px", lineHeight: "15px", display: "flex", alignItems: "center", textAlign: "center", color: "#000000", justifyContent: "center" },
  cardContent: { display: "flex", flexDirection: "column", alignItems: "flex-start", padding: "0px", gap: "6px", position: "absolute", left: "16px", top: "26px" },
  itemRow: { display: "flex", flexDirection: "row", alignItems: "center", gap: "16px" },
  iconWrapper: { width: "32px", height: "32px" },
  icon: { width: "32px", height: "32px", objectFit: "contain" },
  cardText: { fontFamily: "Helvetica", fontStyle: "normal", fontWeight: 400, fontSize: "11px", lineHeight: "15px", textTransform: "capitalise", color: "#000000", whiteSpace: "nowrap" },
};
